export default function TermsNotice({
  className = "mt-4"
}: {
  className?: string
}) {
  return (
    <p
      data-testid="auth-terms-notice"
      className={`login-muted-text ${className}`}
    >
      {"By continuing you agree to our "}
      <a
        data-testid="auth-terms-link"
        href="https://www.orbitshift.ai/privacy-policy"
        className="login-link-subtle"
        target="_blank"
        rel="noopener noreferrer"
      >
        terms
      </a>
      {" and "}
      <a
        data-testid="auth-privacy-link"
        href="https://www.orbitshift.ai/privacy-policy"
        className="login-link-subtle"
        target="_blank"
        rel="noopener noreferrer"
      >
        privacy notice
      </a>
      .
    </p>
  )
}
